module.exports = __webpack_public_path__ + "assets/img/smartTV-module5-11.e096652c.jpg";